import { useAuth } from '@/lib/auth';

export default function UserBadge() {
  const { profile, loading } = useAuth();

  return (
    <div className="text-left min-w-0">
      {loading ? (
        <p className="text-xs text-text-muted leading-tight">Loading...</p>
      ) : (
        <>
          <p className="text-xs font-semibold text-text-primary leading-tight truncate max-w-[100px] sm:max-w-[160px]">
            {profile?.displayName ?? '—'}
          </p>
          <p className="text-[10px] font-bold uppercase tracking-wider text-text-muted leading-tight">
            {profile?.role === 'admin' ? 'Admin' : profile?.role === 'scorer' ? 'Scorer' : profile?.role === 'viewer' ? 'Viewer' : '—'}
          </p>
        </>
      )}
    </div>
  );
}
